import HomePage from './pages/Home/HomePage';
import Reclami from './pages/Reclami/Reclami';
import ChiSiamo from './pages/ChiSiamo/ChiSiamo';
import CosaFacciamo from './pages/CosaFacciamo/CosaFacciamo';
import Prodotti from './pages/Prodotti/Prodotti';
import PerChi from './pages/PerChi/PerChi';
import LavoraConNoi from './pages/LavoraConNoi/LavoraConNoi';
import Contatti from './pages/Contatti/Contatti';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: <HomePage/>
    },
    // {
    //     path: '/chi-siamo/',
    //     name: 'Chi Siamo',
    //     component: <ChiSiamo/>
    // },
    // {
    //     path: '/cosa-facciamo/',
    //     name: 'Cosa Facciamo',
    //     component: <CosaFacciamo/>
    // },
    // {
    //     path: '/prodotti/',
    //     name: 'Prodotti',
    //     component: <Prodotti/>
    // },
    // {
    //     path: '/per-chi/',
    //     name: 'Per Chi',
    //     component: <PerChi/>
    // },
    // {
    //     path: '/lavora-con-noi/',
    //     name: 'Lavora Con Noi',
    //     component: <LavoraConNoi/>
    // },
    // {
    //     path: '/contatti/',
    //     name: 'Contatti',
    //     component: <Contatti/>
    // },  
    {
        path: '/reclami/',
        name: 'Reclami',
        component: <Reclami/>
    },
]

export default routes;
